export default __webpack_public_path__ + "static/media/hht1_ep05_timeline_03.062c9b81.png";